import { Alert } from '@zopauk/web-ui';
import { twMerge } from 'tailwind-merge';
import type { HTMLAttributes } from 'react';
import { Placeholder } from './Placeholder';
import { useQuery } from '@tanstack/react-query';
import type { Channels } from './Calculator/types';
import { getRepresentativeApr } from '@/utils/queries/getRepresentativeApr';
import { type StructuredTextGraphQlResponse, StructuredText } from 'react-datocms';
import { representativeAprTextTransformer } from '@/utils/representativeAprTextTransformer';
import { paragraphRule, listItemRule, headingRule, anchorRule, listRule } from './structuredText';

type RepresentativeAprProps = {
  copy: StructuredTextGraphQlResponse['value'];
  channel?: Channels;
} & HTMLAttributes<HTMLDivElement>;

export const RepresentativeApr = ({ channel = 'upl', className = '', copy, ...rest }: RepresentativeAprProps) => {
  const { error, data } = useQuery({
    queryFn: () => getRepresentativeApr({ channel }),
    queryKey: ['repApr', channel],
  });

  if (data?.data.repPrice && copy) {
    return (
      <div className={twMerge(`representative-apr-module ${className}`)} {...rest}>
        <StructuredText
          customNodeRules={[paragraphRule, listRule, listItemRule, anchorRule, headingRule]}
          renderText={representativeAprTextTransformer(data.data.repPrice)}
          data={{ value: copy }}
        />
      </div>
    );
  }

  if (error) {
    return (
      <Alert variant="warning" className="mb-6">
        Unable to fetch the Example Representative APR
      </Alert>
    );
  }

  return (
    <div className="relative before:h-[25px] before:mb-6 after:h-[40px]">
      <Placeholder className="h-[60px]" />
      <Placeholder className="h-[60px]" />
    </div>
  );
};
